<template>
  <li
    :aria-selected="selected"
    :style="style"
    :class="[
      ns.be('dropdown', 'option-item'),
      ns.is('selected', selected),
      ns.is('disabled', disabled),
      ns.is('created', created),
      { hover: hovering },
    ]"
    @mouseenter="hoverItem"
    @click.stop="selectOptionClick"
  >
    <template v-if="isMultiple && componentName === currentComponentName">
      <jd-checkbox
        :disabled="disabled"
        :model-value="selected"
        :index="index"
        @click.stop="selectOptionClick"
      >
        <slot :item="item">
          <span>{{ item.label }}</span>
        </slot>
      </jd-checkbox>
    </template>
    <template v-else>
      <slot :item="item" :index="index" :disabled="disabled">
        <span>{{ item.label }}</span>
      </slot>
    </template>
  </li>
</template>

<script lang="ts">
import { computed, defineComponent, getCurrentInstance, inject } from 'vue'
import { useNamespace } from '@jdesign-vue/hooks'
import JdCheckbox from '@jdesign-vue/components/checkbox'
import { useOption } from './useOption'
import { OptionProps } from './defaults'
import { selectV2InjectionKey } from './token'

const currentComponentName = 'RcOptionItem'

export default defineComponent({
  name: currentComponentName,
  componentName: currentComponentName,
  components: {
    JdCheckbox,
  },
  props: OptionProps,
  emits: ['select', 'hover'],
  setup(props, { emit }) {
    const ns = useNamespace('select')
    const parentSelect = inject(selectV2InjectionKey)!
    const isMultiple = computed(() => parentSelect.props.multiple)
    const componentName = getCurrentInstance()?.type?.name
    const { hoverItem, selectOptionClick } = useOption(props, { emit })
    return {
      ns,
      hoverItem,
      selectOptionClick,
      isMultiple,
      componentName,
      currentComponentName,
    }
  },
})
</script>
